import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import styled from 'styled-components'
import QMLogo from '../static/images/navigation/qm_logo_nav.svg'
import UserOrgMenu from '../components/navigation/UserOrgMenu'
import NavItem from '../components/navigation/NavItem'
import AllQuestsActiveIcon from '../static/images/navigation/all_quests_active.svg'
import AllQuestsInactiveIcon from '../static/images/navigation/all_quests_inactive.svg'
import AllQuestsHoverIcon from '../static/images/navigation/all_quests_hover.svg'
import MyQuestsActiveIcon from '../static/images/navigation/my_quests_active.svg'
import MyQuestsInactiveIcon from '../static/images/navigation/my_quests_inactive.svg'
import MyQuestsHoverIcon from '../static/images/navigation/my_quests_hover.svg'
import ProductionStatusActiveIcon from '../static/images/navigation/production_status_active.svg'
import ProductionStatusInactiveIcon from '../static/images/navigation/production_status_inactive.svg'
import ProductionStatusHoverIcon from '../static/images/navigation/production_status_hover.svg'
import QueueActiveIcon from '../static/images/navigation/queue_active.svg'
import QueueInactiveIcon from '../static/images/navigation/queue_inactive.svg'
import QueueHoverIcon from '../static/images/navigation/queue_hover.svg'
import TopicsActiveIcon from '../static/images/navigation/topics_active.svg'
import TopicsInactiveIcon from '../static/images/navigation/topics_inactive.svg'
import TopicsHoverIcon from '../static/images/navigation/topics_hover.svg'
import ReviewsActiveIcon from '../static/images/navigation/reviews_active.svg'
import ReviewsInactiveIcon from '../static/images/navigation/reviews_inactive.svg'
import ReviewsHoverIcon from '../static/images/navigation/reviews_hover.svg'
import {
  isOnAllQuestsRoute,
  isOnQueueRoute,
  isOnNavRoute,
  userCanSeeQueue,
  userCanSeeMyQuests,
  userCanSeeReviewQueue,
  userCanSeeProductionStatus
} from '../utils/navigation'
import { isMentorAuthor } from '../utils/user'

const Nav = styled.div`
  position: fixed;
  height: 100%;
  width: 72px;
  top: 0;
  left: 0;
  padding: 0;
  background-color: #4e6c84;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  z-index: 99;
  display: flex;
  flex-direction: row;
  flex-direction: column;
  align-items: center;

  .user-org-menu-nav .user-photo-wrapper {
    height: 38px;
    width: 38px;
  }

  &.hidden {
    display: none;
  }
`

const QMLogoStyled = styled.div`
  background: url(${QMLogo}) no-repeat;
  height: 105px;
  width: 72px;
  text-align: center;
  top: 20px;
  display: inline-block;
  z-index: 1;
  background-size: contain;
  flex-shrink: 0;
  padding-bottom: 10px;
`

const UserMenuContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: auto;
`

const DividerLine = styled.div`
  border-top: 1px solid #151f28;
  opacity: 0.33;
  width: 100%;
`

const NavItemContainer = styled.div`
  margin-bottom: 50px;
  position: relative;
`

const QueueCount = styled.div`
  height: 15px;
  border-radius: 8px;
  background-color: #263746;
  color: #ffffff;
  font-size: 9px;
  text-align: center;
  right: -19px;
  top: -11px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  position: absolute;
`

class NavContainer extends React.Component {
  render() {
    const { user, path, stats, organizationId, dispatch, courses } = this.props

    if (!user) {
      return null
    }

    const org = user.organizations.find(function (o) {
      return o.id === organizationId
    })

    const formattedAssignedQuestsCount =
      stats.assigned_quests_count > 999 ? '999+' : stats.assigned_quests_count

    return (
      <Nav id="side-nav">
        <QMLogoStyled />
        {isMentorAuthor(user) ? (
          ''
        ) : (
          <React.Fragment>
            {userCanSeeQueue(user) && (
              <NavItemContainer>
                <NavItem
                  label="Queue"
                  activeIcon={QueueActiveIcon}
                  inactiveIcon={QueueInactiveIcon}
                  hoverIcon={QueueHoverIcon}
                  height="19px"
                  width="28px"
                  handleClick={() => dispatch(push('/queue'))}
                  isActive={isOnQueueRoute(path)}
                />
                <QueueCount>{formattedAssignedQuestsCount}</QueueCount>
              </NavItemContainer>
            )}

            {userCanSeeProductionStatus(user, courses) && (
              <NavItemContainer>
                <NavItem
                  label="Production Status"
                  activeIcon={ProductionStatusActiveIcon}
                  inactiveIcon={ProductionStatusInactiveIcon}
                  hoverIcon={ProductionStatusHoverIcon}
                  height="22px"
                  width="25px"
                  handleClick={() => dispatch(push('/productionstatus'))}
                  isActive={isOnNavRoute(path, 'productionstatus')}
                />
              </NavItemContainer>
            )}

            {userCanSeeMyQuests(user) && (
              <NavItemContainer>
                <NavItem
                  label="My Quests"
                  activeIcon={MyQuestsActiveIcon}
                  inactiveIcon={MyQuestsInactiveIcon}
                  hoverIcon={MyQuestsHoverIcon}
                  height="24px"
                  width="25px"
                  handleClick={() => dispatch(push('/myquests'))}
                  isActive={isOnNavRoute(path, 'myquests')}
                />
              </NavItemContainer>
            )}

            <NavItemContainer>
              <NavItem
                label="All Quests"
                activeIcon={AllQuestsActiveIcon}
                inactiveIcon={AllQuestsInactiveIcon}
                hoverIcon={AllQuestsHoverIcon}
                height="19px"
                width="26px"
                handleClick={() => dispatch(push('/quests'))}
                isActive={isOnAllQuestsRoute(path)}
              />
            </NavItemContainer>

            <NavItemContainer>
              <NavItem
                label="Topics"
                activeIcon={TopicsActiveIcon}
                inactiveIcon={TopicsInactiveIcon}
                hoverIcon={TopicsHoverIcon}
                height="25px"
                width="21px"
                handleClick={() => dispatch(push('/topicclouds'))}
                isActive={isOnNavRoute(path, 'topicclouds')}
              />
            </NavItemContainer>

            {userCanSeeReviewQueue(user) && (
              <NavItemContainer>
                <NavItem
                  label="Reviews"
                  activeIcon={ReviewsActiveIcon}
                  inactiveIcon={ReviewsInactiveIcon}
                  hoverIcon={ReviewsHoverIcon}
                  height="18px"
                  width="27px"
                  handleClick={() => dispatch(push('/reviewqueue'))}
                  isActive={isOnNavRoute(path, 'reviewqueue')}
                />
              </NavItemContainer>
            )}
          </React.Fragment>
        )}
        <UserMenuContainer>
          <UserOrgMenu user={user} organization={org} dispatch={dispatch} />
        </UserMenuContainer>
      </Nav>
    )
  }
}

NavContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  courses: PropTypes.array.isRequired,
  stats: PropTypes.object,
  organizationId: PropTypes.number
}

export const mapStateToProps = state => ({
  path: window.location.pathname,
  user: state.user.user,
  courses: state.mockcourses.items,
  stats: state.user.stats,
  organizationId: state.organization.orgId
})

export default connect(mapStateToProps)(NavContainer)
export { NavContainer as NavContainerDisconnected }



// WEBPACK FOOTER //
// ./src/containers/Nav.js